//stars version

import React, { useContext, useEffect, useState } from "react";
import styles from "./Review.module.scss";
import { Context } from "../Store";
import { isMobile } from "react-device-detect";
import { trackEvent } from "../utils/helpers";

const ReviewB = () => {
  const [state] = useContext(Context);
  const [hoveredStars, setHoveredStars] = useState(0);

  const googleReviewUrl = state.googleurl;
  const otherReviewUrl = state.feedbackurl;
  const isUkOrUsStory = state.country === "uk" || state.country === "us";

  useEffect(() => {
    trackEvent("ab_test_reviews", "Variant Seen", "stars");
  }, []);

  const handleStarClick = (starIndex) => {
    trackEvent("Google Review", "Circle Clicked", `${starIndex} circle`);
    // if (!googleReviewUrl) return;
    if (isUkOrUsStory && googleReviewUrl) {
      window.open(googleReviewUrl, "_blank", "noopener,noreferrer");
    } else if (otherReviewUrl) {
      window.open(otherReviewUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <div className={styles.reviewContainer}>
        <div
          className={styles.stripeBg}
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/img/${isMobile ? "stripeBgMob" : "stripeBg"}.png)`,
          }}
        />
        <div className={styles.rateGoogle}>
          <div className={styles.dartContainer}>
            <img src="./img/dartHorizontal.svg" alt="Dart" />
          </div>
          <h4>How do you like us?</h4>
          <p>
            {isUkOrUsStory ? "Rate us below and drop a Google review" : "Rate us below and drop a review"}
          </p>
          <div className={styles.stars} onMouseLeave={() => setHoveredStars(0)}>
            {[...Array(5)].map((_, index) => (
              <button
                key={index}
                type="button"
                className={`${styles.starButton} ${hoveredStars >= index + 1 ? styles.starActive : ""}`}
                onMouseEnter={() => setHoveredStars(index + 1)}
                onClick={() => handleStarClick(index + 1)}
                aria-label={`Rate ${index + 1} stars`}
              >
                <svg
                  className={styles.starSvg}
                  width="22"
                  height="20"
                  viewBox="0 0 22 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.30843 6.58046L10.5747 0L13.841 6.58046L21.1494 7.64368L15.8621 12.7682L17.1073 20L10.5747 16.5805L4.04215 20L5.28736 12.7682L0 7.64368L7.30843 6.58046Z"
                    fill="#D8B464"
                  />
                </svg>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewB;
